import React from "react";
import {
  DropdownAction,
  DefaultColumnBuilder as builder,
} from "../../components/ColumnBuilder";
import { Adapter } from "../../../types/adapter";
import { Table, TablePaginationConfig } from "antd";

export interface AdapterListProps {
  loading: boolean;
  records: Adapter[];
  editable?: boolean;
  actions?: DropdownAction[];
  pagination?: TablePaginationConfig | false;
  onChange?: (pagination: TablePaginationConfig) => void;
  selectRecods?: (ids: number[]) => void;
  viewRecord?: (id: number) => void;
  editRecord?: (id: number) => void;
  copyRecord?: (id: number) => void;
  removeRecord?: (id: number) => void;
  visibleColumns?: string[];
}

export const getAdapterColumns = (
  editable?: boolean,
  actions?: DropdownAction[],
  callbacks?: {
    viewRecord?: (id: number) => void;
    editRecord?: (id: number) => void;
    copyRecord?: (id: number) => void;
    removeRecord?: (id: number) => void;
  }
) => {
  let columns = [
    builder.id,
    builder.platform("platform"),
    builder.text("Status", "status", true),
    builder.date("Created At", "createdAt"),
    builder.version,
    builder.adType("Ad Type", "adTypes"),
  ];

  if (editable) {
    const action = builder.dropdown(
      actions || [
        DropdownAction.VIEW,
        DropdownAction.EDIT,
        DropdownAction.COPY,
        DropdownAction.DELETE,
      ],
      (id, action) => {
        console.log(id, action);
        switch (action) {
          case DropdownAction.VIEW:
            return callbacks?.viewRecord?.(id);
          case DropdownAction.EDIT:
            return callbacks?.editRecord?.(id);
          case DropdownAction.COPY:
            return callbacks?.copyRecord?.(id);
          case DropdownAction.DELETE:
            return callbacks?.removeRecord?.(id);
        }
      }
    );
    columns.push(action);
  }

  return columns;
};

export const AdapterList = (props: AdapterListProps) => {
  const columns = () => {
    let columns = getAdapterColumns(props.editable, props.actions, {
      viewRecord: props.viewRecord,
      editRecord: props.editRecord,
      copyRecord: props.copyRecord,
      removeRecord: props.removeRecord,
    });

    // Filter by visible columns (always show action column with fixed="right")
    if (props.visibleColumns && props.visibleColumns.length > 0) {
      columns = columns.filter(
        (c) => c.fixed === "right" || props.visibleColumns!.includes(c.dataIndex?.toString() || "")
      );
    }

    return columns;
  };

  const rowSelection = {
    onChange: (_: React.Key[], selectedRows: any[]) => {
      props.selectRecods?.(selectedRows.map((row) => row.key));
    },
  };

  return (
    <Table
      loading={props.loading}
      columns={columns()}
      pagination={props.pagination}
      dataSource={(props.records || []).map((record) => ({
        ...record,
        key: record.id,
      }))}
      onChange={props.onChange}
      onRow={(record) => ({
        onClick: () => {
          if (record.id !== undefined) props.viewRecord?.(record.id);
        },
      })}
      rowSelection={props.selectRecods && rowSelection}
    />
  );
};
